import { AppState } from '../AppTypes';

export const _allFlagsEnabled = (state: AppState) => {
  return (flags: string[]): boolean => {
    if (import.meta.env.DEV) {
      return flags.every(flag => state.flags.includes(flag));
    }
    return flags.every(flag => state.ldClient.variation(flag, false) === true);
  };
};
